import React from "react";
import { Formik, Form } from "formik";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { InputLabel } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";

import { addOrEditHR } from "../../../../store/ducks/duckHr";
import { BorderLinearProgress } from "../../../../components/LoadingComponent";

const ManagementHrForm = ({ initialValues, isEdit, handleClose, open }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={(values) => {
          let errors = {};

          if (!values.name) {
            errors.name = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          values = {
            ...values,
            id: values.id === 0 ? 0 : values.id,
          };

          let message = values.id > 0 ? "Edited" : "Added";

          return dispatch(addOrEditHR(values, () => setSubmitting(false))).then(() => {
            handleClose();
            enqueueSnackbar(`${message} '${values.name}' HR Document Successfully`, {
              variant: "success",
            });
          });
        }}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="md"
              open={open}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">
                {isEdit && initialValues?.id !== 0
                  ? "Edit"
                  : !isEdit && initialValues?.id !== 0
                    ? "Details"
                    : "Add"}
              </DialogTitle>
              <DialogContent style={{ overflowY: initialValues.id !== 0 ? "scroll" : "hidden" }}>
                <Grid container spacing={2}>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                      justifyContent: "left",
                    }}
                  >
                    <Grid item xs={4}>
                      <InputLabel id="labelName">Name</InputLabel>
                      <Select
                        fullWidth
                        id="demo-simple-select-filled"
                        labelId="labelName"
                        margin="dense"
                        name="name"
                        variant="outlined"
                        onChange={(e) => (values.name = e.target.value)}
                      >
                        <MenuItem value="Informe TurnOver">Informe TurnOver</MenuItem>
                        <MenuItem value="Informe Capacitación">Informe Capacitación</MenuItem>
                        <MenuItem value="Informe trimestral Dotación">
                          Informe trimestral Dotación
                        </MenuItem>
                        <MenuItem value="Programa JP: TACO">Programa JP: TACO</MenuItem>
                        <MenuItem value="Asignaciones Internacionales">
                          Asignaciones Internacionales
                        </MenuItem>
                        <MenuItem value="Informe Empleos y RRUU">Informe Empleos y RRUU</MenuItem>
                      </Select>
                    </Grid>

                    <Grid item xs={4}>
                      <InputLabel id="labelFiscalYear">Fiscal Year</InputLabel>
                      <Select
                        fullWidth
                        id="demo-simple-select-filled"
                        labelId="labelFiscalYear"
                        margin="dense"
                        name="fiscalYear"
                        variant="outlined"
                        onChange={(e) => (values.fiscalYear = e.target.value)}
                      >
                        <MenuItem value="2023-2024">2023-2024</MenuItem>
                        <MenuItem value="2024-2025">2024-2025</MenuItem>
                        <MenuItem value="2025-2026">2025-2026</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={handleClose}>
                  Close
                </Button>
                {isEdit && (
                  <Button color="primary" variant="contained" onClick={submitForm}>
                    Save
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ManagementHrForm;
